import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import FormButton from '@components/form/form-button';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle
} from '@components/modal';
import { ROUTES } from '@constants/routes';
import { useVismaConfiguration } from '@services/visitor-management';

interface ConfirmModalProps {
  open: boolean;
  closeModal: () => void;
  title?: string;
  description?: string;
  onQuit?: () => void;
  leftButtonTitle?: string;
  rightButtonTitle?: string;
  leftButtonVariant?:
    'outlined' | 'solid' | 'filled' | 'dashed' | 'link' | 'text';
  rightButtonVariant?:
    'outlined' | 'solid' | 'filled' | 'dashed' | 'link' | 'text';
  leftButtonType?: 'default' | 'primary' | 'dashed' | 'link' | 'text';
  rightButtonType?: 'default' | 'primary' | 'dashed' | 'link' | 'text';
  leftButtonWithArrow?: boolean;
  rightButtonWithArrow?: boolean;
}

function ConfirmModal({
  open,
  closeModal,
  title,
  description,
  onQuit,
  leftButtonTitle,
  rightButtonTitle,
  leftButtonVariant = 'outlined',
  rightButtonVariant,
  leftButtonType,
  rightButtonType = 'primary',
  leftButtonWithArrow = true,
  rightButtonWithArrow = true
}: ConfirmModalProps) {
  const navigate = useNavigate();
  const intl = useIntl();
  const { configuration } = useVismaConfiguration();
  const gi = configuration?.generalInformation;
  const handleQuit = () => {
    if (onQuit) {
      onQuit();
    } else {
      navigate(ROUTES.VR_WELCOME);
    }
    closeModal();
  };
  return (
    <Modal open={open} onCancel={closeModal} footer={null}>
      <ModalTitle>
        {title ?? intl.formatMessage({ id: 'ARE_YOU_SURE' })}
      </ModalTitle>
      <ModalContent>
        {description ?? intl.formatMessage({ id: 'ARE_YOU_SURE_DESC' })}
      </ModalContent>
      <ModalFooter>
        <FormButton
          withRightArrow={leftButtonWithArrow}
          type={leftButtonType}
          variant={leftButtonVariant}
          onClick={closeModal}
        >
          {leftButtonTitle ??
            gi?.button_quit ??
            intl.formatMessage({ id: 'QUIT' })}
        </FormButton>
        <FormButton
          withRightArrow={rightButtonWithArrow}
          type={rightButtonType}
          variant={rightButtonVariant}
          onClick={handleQuit}
        >
          {rightButtonTitle ??
            gi?.button_continue ??
            intl.formatMessage({ id: 'CONTINUE' })}
        </FormButton>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmModal;
